import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Container,
  Logo,
  LogoMobile,
  LogoMobileFooter,
  Header,
  HeaderMobile,
  FormContainer,
  LoginTitle,
  LoginBox,
  LeftContainer,
  RightContainer,
  Background,
  GradienteCenter,
  ImageCenterContainer,
  GradienteMobileImage
} from "../styles";
import {
  ConfirmationContainer,
  ConfirmationIcon,
} from "~/components/pages/SignUp/Steps/styles";
import SliderImages from '~/components/layout/SliderImages';
import { SignInButton } from "~/pages/Auth/SingIn/styles";
import api from "~/services/api";
import LogoMap from '~/assets/images/Login/meu-app-branca.png';
import LogoWhite from '~/assets/images/Login/logo-branca.png';

function Confirmation(props) {
  const dispatch = useDispatch();
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState("");
  const [userId, setUserId] = useState("");

  useEffect(() => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let tokenParam = params.get("token");
    let userIdParam = params.get("user-id");
    let contactIdParam = params.get("contact-id");

    if (tokenParam) {
      setToken(tokenParam);
      setUserId(userIdParam);
      confirmationUser(userIdParam, tokenParam, contactIdParam);
    } else {
      window.location.href = "/";
    }
  }, []);

  function confirmationUser(userId, token, contactId) {
    const header = {
      "Content-Type": "application/json",
      "Accept-Language": "pt-BR",
    };
    const parameters = {
      method: "POST",
      headers: header,
    };
    const body = {
      token: token,
    };

    api
      .post(
        `/residential/store/v1/users/${userId}/validations`,
        body,
        parameters
      )
      .then((res) => {
        setSuccess(true);

        dispatch({
          type: "SET_REGISTRATION_TOKEN",
          token: token,
        });
        dispatch({
          type: "ADD_LOCATION",
          location: `/residential/store/v1/users/${userId}`,
        });
        if (contactId) {
          dispatch({
            type: "ADD_CONTACT",
            email: "",
            contactId: contactId,
          });
        }
        localStorage.setItem("userId", userId);
        localStorage.removeItem('X-MFA-Hash');
      })
      .catch((err) => {
        setSuccess(false);
        if (err.response && err.response.data && err.response.data[0]) {
          setErrorMessage(err.response.data[0].message);
        }
      });
  }

  return (
    <Background>
      <GradienteCenter/>
      <GradienteMobileImage />
      <Container>
      <LeftContainer>
          <>
            <img src={LogoWhite} alt='Ultragas'/>
          </>
        </LeftContainer>
        <ImageCenterContainer>
          <SliderImages />
        </ImageCenterContainer>
        <RightContainer>
          <LoginBox>
          <Header className="pt-4 pb-4">
              <Logo src={LogoMap} alt='MAP'/>
            </Header>
            <HeaderMobile className="pt-4 pb-4">
              <LogoMobile src={LogoWhite} alt='UltraGaz'/>
            </HeaderMobile>
            <FormContainer>
              <LoginTitle className="mb-3">Primeiro Acesso</LoginTitle>
              {success ? (
                <ConfirmationContainer>
                  <ConfirmationIcon className="fa fa-check-circle-o" />
                  <div className="w-100 text-center mt-4">
                    <h6
                      style={{
                        fontSize: 19,
                        color: "#4D565C",
                        marginTop: -10,
                        marginBottom: 10,
                      }}
                    >
                      <b>Usuário validado com sucesso</b>
                    </h6>
                    <p className="mt-4" style={{ fontWeight: "200" }}>
                      Clique no botão abaixo para criar sua senha
                    </p>
                  </div>

                  <SignInButton
                    className="mt-3"
                    onClick={() => {
                      window.location.pathname = "/primeiro-acesso";
                    }}
                  >
                    <span>Criar Senha</span>
                  </SignInButton>
                </ConfirmationContainer>
              ) : (
                <ConfirmationContainer>
                  <ConfirmationIcon className="fa fa-times-circle-o" />
                  <div className="w-100 text-center mt-4">
                    <h6
                      style={{
                        fontSize: 19,
                        color: "#4D565C",
                        marginTop: -10,
                        marginBottom: 10,
                      }}
                    >
                      <b>Não foi possível validar o usuário</b>
                    </h6>
                    <p className="mt-4" style={{ fontWeight: "200" }}>
                      {errorMessage}
                    </p>
                  </div>

                  <SignInButton
                    className="mt-3"
                    onClick={() => {
                      window.location.pathname = "/acessar";
                    }}
                  >
                    <span>Acessar</span>
                  </SignInButton>
                </ConfirmationContainer>
              )}
            </FormContainer>
            <HeaderMobile className="pt-4 pb-4">
              <LogoMobileFooter src={LogoMap} alt='UltraGaz'/>
            </HeaderMobile>
          </LoginBox>
        </RightContainer>
      </Container>
    </Background>
  );
}

export default Confirmation;